(ns hai.users.helper
  (:require
   [clojure.string :as str]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.rf-sugar :refer [>e]]))

;; Plain keywords: the platform pads user rows so every key resolves (nil OK),
;; no pathom-optional marks needed. Keep this to attrs the `user` resolver can
;; produce from a bare `:user/uuid` — anything else (e.g. `:user/credits`, only
;; output by the `:users/table` resolver) breaks queries that reach users
;; through a join, like `:group/members`.
(def query
  [:user/uuid
   :user/email
   :user/full-name])

(defn ->label-with-email
  [{:user/keys [email full-name]}]
  (str (not-empty full-name)
       " "
       (str/join ", " email)))

(defn ->label
  [{:user/keys [email full-name]}]
  (or (not-empty full-name)
      (str/join ", " email)))

(defn field-render
  [user]
  [table/title-render
   {:title (->label user)
    :on-click (fn [_]
                (>e [:routing/navigate [:users/edit user]]))}])
